import AccountApi from "@/services/account.api";

const SELECTED_COMPANY_ID_KEY = "company_selected_id";

const vuex = {};

vuex.state = {
  loading: false,
  companies: [],
  selectedCompanyId: sessionStorage.getItem(SELECTED_COMPANY_ID_KEY) || null,
  isAccountVerified: null,
  accountEmail: null,
};

vuex.getters = {
  loading: (state) => state.loading,
  companies: (state) => state.companies,
  hasOrganizations: (state) => state.companies.length > 0,
  selectedCompanyId: (state) => state.selectedCompanyId,
  selectedCompany: (state) =>
    state.companies.find((company) => company?.id === state.selectedCompanyId),
  canManageSelectedCompanyEmployees: (state, getters) =>
    getters.selectedCompany?.canManageEmployees === true,
  accountApi: () => new AccountApi(),
  isAccountVerified: (state) => state.isAccountVerified,
  accountEmail: (state) => state.accountEmail,
};

vuex.mutations = {
  setLoading: (state, payload) => {
    state.loading = payload;
  },

  setCompanies: (state, payload) => {
    state.companies = payload;
  },

  setSelectedCompanyId: (state, payload) => {
    state.selectedCompanyId = payload;

    if (payload != null) {
      sessionStorage.setItem(SELECTED_COMPANY_ID_KEY, payload);
    } else {
      sessionStorage.removeItem(SELECTED_COMPANY_ID_KEY);
    }
  },
  setIsAccountVerified: (state, payload) => {
    state.isAccountVerified = payload;
  },
  setAccountEmail: (state, payload) => {
    state.accountEmail = payload;
  },
};

vuex.actions = {
  async fetchOrganizations({ commit, state, getters }) {
    if (state.loading) return;

    try {
      commit("setLoading", true);

      const { data } = await getters.accountApi.getAccount();

      commit("setIsAccountVerified", data?.isVerified !== false);
      commit("setAccountEmail", data?.email);

      const companiesById = new Map();

      (data?.companyCustomers ?? []).forEach((customer) => {
        const company = customer?.company;

        if (!company?.id) return;

        const canManageEmployees = customer.isCompanyEmployeeManager === true;

        const existing = companiesById.get(company.id);

        companiesById.set(company.id, {
          ...company,
          canManageEmployees:
            existing?.canManageEmployees || canManageEmployees,
        });
      });

      commit("setCompanies", [...companiesById.values()]);
    } catch (error) {
      console.error("Failed to get organization information: ", error);
      commit("setCompanies", []);
    } finally {
      commit("setLoading", false);
    }
  },
};

export default {
  namespaced: true,
  state: vuex.state,
  getters: vuex.getters,
  mutations: vuex.mutations,
  actions: vuex.actions,
};
